import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

export const createTrendsActions = (types, api) => ({
  setStatusFilter: createAction(types.SET_STATUS_FILTER),
  setCurrentPage: createAction(types.SET_CURRENT_PAGE),
  setTestsByBuild: createAction(types.SET_TESTS_BY_BUILD),
  cleanup: createAction(types.CLEAN_UP),
  getTestTrends: createApiAction(
    types.GET_TEST_TRENDS,
    (payload) => api.getTrends(payload).then(({ data }) => ({
      ...data,
      start: payload.start,
      end: payload.end,
    })),
  ),
  getTestErrors: createApiAction(
    types.GET_TEST_ERRORS,
    (payload) => api.getAggregatedTestErrors(payload),
  ),
  getBuildsTests: createApiAction(
    types.GET_BUILDS_TESTS,
    (payload) => api.getBuildsTests(payload),
  ),
  getTests: createApiAction(
    types.GET_TESTS,
    (payload) => api.getTests(payload),
  ),
  getTestsByBuild: createApiAction(
    types.GET_TESTS_BY_BUILD,
    (payload) => api.getTests(payload),
  ),
});
